import { BrowserRouter, Route, Switch } from 'react-router-dom';
import React, { Component } from 'react';

import LocalStorageManager from './managers/LocalStorageManager.js';
import CookieManager from './managers/CookieManager.js';

//#region Custom

import Navigation from './components/Navbar.jsx';
import ErrorPage from './pages/Error.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Home from './pages/Home.jsx';

import ReLoginPopup from './components/ReLoginPopup.jsx';
import InfoSnackbar from './components/InfoSnackbar.jsx';
import Footer from './components/Footer.jsx';
import Register from './pages/Register.jsx';
import WarningPopup from './components/WarningPopup.jsx';
import WeightStatusCard from './components/WeightStatusCard.jsx';
import ShopClosingCard from './components/ShopClosingCard.jsx';

//#endregion Custom

import "./App.css";
import { Card } from 'react-bootstrap';
import { CardContent, Button, CardHeader } from '@mui/material';

import ClientAPI from './service/ClientAPI.js';
import UpdateShopOpenings from './components/UpdateShopDates.jsx';
import UpdateTotalWeight from './components/UpdateTotalWeight.jsx';
import Account from './pages/Account.jsx';

import 'bootstrap/dist/css/bootstrap.min.css';
import ResetPasswordPage from './pages/ResetPassword.jsx';
import Impressum from './pages/Impressum.jsx';
import InfoToPricingPage from './pages/InfoToPricing.jsx';
import AttentionToPricingAndOrdersPopup from './components/AttentionToPricingAndOrdersPopup.jsx';
import DashboardAlleKunden from './pages/DashboardAlleKunden.jsx';
import DashboardAlleProdukte from './pages/DashboardAlleProdukte.jsx';
import DashboardEmailMarketing from './pages/DashboardEmailMarketing.jsx';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      weight: 0,
      loaded: false,
      isLoggedIn: CookieManager.Get("auth") !== null,
      maxWeight: 3000,
      isAdmin: LocalStorageManager.Get("admin") === "1",
      showShopOpeningsPopup: false,
      showMaxWeightPopup: false
    }
  }

  componentDidMount() {
    ClientAPI.GetStoreInfo()
      .then((_data) => {
        this.setState({ startDate: new Date(_data.Start), endDate: new Date(_data.End), weight: _data.Weight, maxWeight: _data.MaxWeight, loaded: true });
      })
      .catch(_err => console.error(_err));
  }

  handleChangeShopOpeningTimesClick = () => {
    this.setState({ showShopOpeningsPopup: true });
  }

  handleChangeTotalWeightClick = () => {
    this.setState({ showMaxWeightPopup: true });
  }

  RenderContent = () => {
    return (
      <div>
        {
          window.location.pathname !== "/impressum" && 
          window.location.pathname !== "/info" && 
          window.location.pathname !== "/account" &&
          window.location.pathname !== "/resetPassword" &&
          window.location.pathname !== "/register" ?
            (
              <div className="importantInfo" style={{ 
                maxWidth: "80%", 
                margin: "20px auto",
                display: "flex",
                flexDirection: "row",
                gap: "16px",
                flexWrap: "wrap"
              }}>
                <WeightStatusCard 
                  weight={this.state.weight}
                  maxWeight={this.state.maxWeight}
                  isAdmin={this.state.isAdmin}
                  onEdit={this.handleChangeTotalWeightClick}
                />
                <ShopClosingCard 
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  isAdmin={this.state.isAdmin}
                  onEdit={this.handleChangeShopOpeningTimesClick}
                />
              </div>
            )
            :
            (<></>)
        }
        <Switch>
          <Route path="/" component={Home} exact={true} />
          <Route path="/dashboard" exact={true} component={Dashboard} />
          <Route path="/dashboardCustomers" exact={true} component={DashboardAlleKunden} />
          <Route path="/dashboardProducts" exact={true} component={DashboardAlleProdukte} />
          <Route path="/dashboardEmail" exact={true} component={DashboardEmailMarketing} />
          <Route path="/register" component={Register} />
          <Route path="/account" component={Account} />
          <Route path="/resetPassword" component={ResetPasswordPage} />
          <Route path="/impressum" component={Impressum} />
          <Route path="/info" component={InfoToPricingPage} />
          <Route component={ErrorPage} />
        </Switch>
        <Footer />
      </div>
    )
  }

  RenderContentForAnonymous = () => (
    <div>
      <Switch>
        <div style={{ minHeight: "95vh" }}>
          <Route path="/register" component={Register} />
          <Route path="/resetPassword" component={ResetPasswordPage} />
          <Route path="/impressum" component={Impressum} />
          <Route path="/info" component={InfoToPricingPage} />
        </div>
      </Switch>
      <Footer />
    </div>
  )

  render() {
    return (
      <BrowserRouter style={{ minHeight: "100vh" }}>
        <div>
          <AttentionToPricingAndOrdersPopup />
          <ReLoginPopup />
          <WarningPopup />
          <Navigation />
          {
            this.state.isLoggedIn ? this.RenderContent() : this.RenderContentForAnonymous()
          }
          <InfoSnackbar />
        </div>
        <UpdateShopOpenings show={this.state.showShopOpeningsPopup} startDate={this.state.startDate} endDate={this.state.endDate} onClose={() => this.setState({ showShopOpeningsPopup: false })} />
        <UpdateTotalWeight show={this.state.showMaxWeightPopup} maxWeight={this.state.maxWeight} onClose={() => this.setState({ showMaxWeightPopup: false })} />
      </BrowserRouter>
    );
  }
}

export default App;
